import React from 'react'
import {
  Box,
  Button,
  ButtonColorVariant,
  Color,
  Display,
  ButtonSize,
  FlexDirection,
} from '@gousto-internal/citrus-react'
import { HelpCentre } from '../../common/tracking'

type SearchShowMoreButtonProps = {
  text: string,
  onClick: () => void,
  query: string,
}

const SearchShowMoreButton = ({ text, onClick, query }: SearchShowMoreButtonProps) => (
  <Box
    display={Display.Flex}
    flexDirection={FlexDirection.Column}
    paddingV={3}
    paddingH={4}
    bg={Color.White}
  >
    <Button
      colorVariant={ButtonColorVariant.Tertiary}
      size={ButtonSize.Medium}
      onClick={onClick}
      data-tracking-action={HelpCentre.HELP_CENTRE_SEARCH_SHOW_RESULTS}
      data-tracking-property={JSON.stringify({
        search_term: query,
      })}
    >
      {text}
    </Button>
  </Box>
)

export { SearchShowMoreButton }
